export default "__VITE_ASSET__DEVWFWdf__"